import { useEffect } from "react";
import { useLocation } from "wouter";
import { getBreadcrumbSchema } from "@shared/breadcrumbs";

const BREADCRUMB_SCRIPT_ID = "bharat-breadcrumb-schema";

/**
 * Keeps the one crawler-rendered BreadcrumbList in sync after client-side
 * navigation. Visible breadcrumbs remain presentational; this is the only
 * client code allowed to manage BreadcrumbList JSON-LD.
 */
export default function BreadcrumbStructuredData() {
  const [location] = useLocation();

  useEffect(() => {
    document.getElementById(BREADCRUMB_SCRIPT_ID)?.remove();

    const schema = getBreadcrumbSchema(location);
    if (!schema) return;

    const script = document.createElement("script");
    script.id = BREADCRUMB_SCRIPT_ID;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => script.remove();
  }, [location]);

  return null;
}
